import { render, staticRenderFns } from "./examAdd.vue?vue&type=template&id=66006c6e&scoped=true&"
import script from "./examAdd.vue?vue&type=script&lang=js&"
export * from "./examAdd.vue?vue&type=script&lang=js&"
import style0 from "./examAdd.vue?vue&type=style&index=0&id=66006c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66006c6e",
  null
  
)

export default component.exports